// extracted by mini-css-extract-plugin
module.exports = {"beer":"sSwBdHg_","wine":"_1_kXXod2","spirits":"_2mbaOxN6","more":"_36ARD1mS"};